// removed by extract-text-webpack-plugin
module.exports = {"container":"ku_g","text":"ku_fs","lowText":"ku_kv ku_fs","underscore":"ku_if","underscoreSlim":"ku_kw ku_if","childrenStyle":"ku_kx"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/Underscore/styles.module.css
// module id = 1234
// module chunks = 27